import { useMemo } from 'react';
import { SuggestionData } from './types';

export const useTextSuggestion = (
  searchTerm: string,
  suggestions: SuggestionData[],
  defaultTextSearch?: boolean,
): SuggestionData[] =>
  useMemo(
    () =>
      (searchTerm !== '' && buildList(searchTerm, suggestions, defaultTextSearch)) || suggestions,
    [searchTerm, suggestions, defaultTextSearch],
  );

const buildList = (
  searchTerm: string,
  suggestions: SuggestionData[],
  defaultTextSearch?: boolean,
): SuggestionData[] => {
  if (defaultTextSearch) {
    return [
      { type: 'TextSuggestion', filters: { text: searchTerm }, id: `text-${searchTerm}` },
      ...suggestions,
    ];
  } else {
    return [
      ...suggestions,
      { type: 'TextSuggestion', filters: { text: searchTerm }, id: `text-${searchTerm}` },
    ];
  }
};
